import './nav-styles.css.js';
import { useMergeRefs } from '@floating-ui/react';
import { withSubComponent } from '@magnetic/higher-order-components';
import { useClassNames } from '@magnetic/hooks';
import React, { forwardRef } from 'react';
import { NavCollapse } from './collapse/index.js';
import { NavDrawer } from './drawer/index.js';
import { DrawerContext } from './drawer/drawer-context.js';
import { useDrawer } from './drawer/use-drawer.js';
import { NavItem } from './item/index.js';
import { NavMenu } from './menu/index.js';
import { NavContext } from './nav-context.js';
import { NavDivider } from './nav-divider.js';
import { useNav } from './use-nav.js';
export { useNav } from './use-nav.js';
export { Icon } from './nav-icons/index.js';
export { navIconMap } from './nav-icons/nav-icon-map.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const RenderNav = /* @__PURE__ */ __name(({
  children,
  className,
  initialIsCollapsed = false,
  isIconOnly = false,
  navZIndex,
  ...rest
}, ref) => {
  const {
    closeDrawer,
    goBack,
    isCollapsed,
    isDrawerOpen,
    openId,
    openLabel,
    selectedIds,
    selectedItemId,
    setIsCollapsed,
    setIsDrawerOpen,
    setOpenDrawerId,
    setOpenId,
    setOpenLabel,
    setSelectedItemId,
    shouldShowBack,
    toggleCollapsed,
    toggleIsDrawerOpen
  } = useNav({ initialIsCollapsed });
  const classNames = useClassNames(
    "mds-rebuild-nav",
    {
      "mds-rebuild-nav-is-collapsed": isCollapsed,
      "mds-rebuild-nav-is-icon-only": isIconOnly
    },
    className
  );
  const { refs, ...drawerContext } = useDrawer({
    isDrawerOpen,
    setIsDrawerOpen
  });
  const mergedRefs = useMergeRefs([refs.setReference, ref]);
  return /* @__PURE__ */ React.createElement("nav", {
    className: classNames,
    id: "mds-left-nav",
    ref: mergedRefs,
    role: "navigation",
    ...rest
  }, /* @__PURE__ */ React.createElement(DrawerContext.Provider, {
    value: {
      refs,
      ...drawerContext
    }
  }, /* @__PURE__ */ React.createElement(NavContext.Provider, {
    value: {
      closeDrawer,
      isIconOnly,
      isCollapsed,
      isDrawerOpen,
      setIsCollapsed,
      setIsDrawerOpen,
      selectedItemId,
      shouldShowBack,
      setSelectedItemId,
      toggleCollapsed,
      toggleIsDrawerOpen,
      goBack,
      setOpenId,
      setOpenLabel,
      setOpenDrawerId,
      navZIndex,
      openId,
      openLabel,
      selectedIds
    }
  }, children)));
}, "RenderNav");
const subComponents = {
  Drawer: NavDrawer,
  Collapse: NavCollapse,
  Menu: NavMenu,
  Item: NavItem,
  Divider: NavDivider
};
const Nav = withSubComponent(forwardRef(RenderNav), subComponents);

export { Nav };
//# sourceMappingURL=index.js.map
